<template>
    <v-card flat tile>
        <v-container grid-list-xs>
            <v-row wrap justify="center" align="center" no-gutters>
                <v-col cols="1">
                    <v-btn icon small @click="prev" class="grey--text">
                        <v-icon x-large>mdi-chevron-left</v-icon>
                    </v-btn>
                </v-col>
                <v-col cols="10">
                    <v-window v-model="index">
                        <v-window-item v-for="i in length" :key="i">
                            <slot :index="index"></slot>
                        </v-window-item>
                    </v-window>
                </v-col>
                <v-col cols="1">
                    <v-btn icon small @click="next" class="grey--text">
                        <v-icon x-large>mdi-chevron-right</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>
        <v-card-actions class="pt-0">
            <v-spacer></v-spacer>
            <v-item-group v-model="index" class="text-xs-center" mandatory>
                <v-item v-for="n in length" :key="n">
                    <v-btn slot-scope="{ active, toggle }" icon small @click="toggle" class="primary--text mx-0">
                        <v-icon>{{ icon(n, active) }}</v-icon>
                    </v-btn>
                </v-item>
            </v-item-group>
            <v-spacer></v-spacer>
        </v-card-actions>
    </v-card>
</template>

<script>
    export default {
        data() {
            return {
                index: 0
            };
        },
        props: {
            length: {
                type: Number,
                required: true
            },
            iconFunction: {
                type: Function,
                default: null
            }
        },
        watch: {
            index: {
                immediate: true,
                handler(value) {
                    this.$emit('change', value);
                }
            }
        },
        methods: {
            icon(n, active) {
                if (this.iconFunction) {
                    let icon = this.iconFunction(n, active);
                    if (icon) {
                        return icon;
                    }
                }

                if (active) {
                    return 'mdi-checkbox-blank-circle';
                }
                return 'mdi-checkbox-blank-circle-outline';
            },
            prev() {
                this.index = this.index - 1 < 0 ? this.length - 1 : this.index - 1;
            },
            next() {
                this.index = this.index + 1 === this.length ? 0 : this.index + 1;
            }
        }
    };
</script>
